import React, { useEffect, useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  logoutUserAsync,
  refreshUserAsync,
  ToggleSessionAlert,
  UpdateSessionAlert,
} from "../redux/authSlice";
import axiosInstance from "../helper/axiosInstance";
import Loader from "../components/Loader";
import AuthRoutes from "./AuthRoutes";
import AdminRoutes from "./AdminRoutes";
import MasterAdminRoutes from "./MasterAdminRoutes";
import Swal from "sweetalert2";

export default function Routes() {
  const dispatch = useDispatch();

  let { userType, showSessiosAlert, userDetails, loading, showUnauthorizedModal } = useSelector(
    (state) => state.auth
  );


  useEffect(() => {
    if (showSessiosAlert && userDetails) {
      Swal.fire({
        text: "Your session has expired due to inactivity.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Logout",
        cancelButtonText: "Extend Session",
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#28a745",
      }).then((result) => {
        if (result.isConfirmed) {
          const loggedInUser = JSON.parse(sessionStorage.getItem("userLoggedDetails"));
          if (!loggedInUser) return;

          const data = {
            id: loggedInUser?.id,
            requestType: '0',
            isSwitch: false,
          };
          dispatch(logoutUserAsync(data));
          sessionStorage.clear();
          dispatch(ToggleSessionAlert(false));
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          console.log("Session extended");
          dispatch(ToggleSessionAlert(false));
        }
      });

    }
  }, [showSessiosAlert, dispatch]);


  const renderRoutes = () => {
    switch (userType) {
      case "UNREGISTERED":
        return <AuthRoutes
        // referTo={referTo} 
        />;
      case "admin":
        return <AdminRoutes />;
      case "masteradmin":
        return <MasterAdminRoutes />;
      default:
        return null;
    }
  };

  const modalStyles = {
    modal: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: "rgba(0, 0, 0, 0.5)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 1000,
    },
    modalContent: {
      background: "white",
      padding: "20px",
      borderRadius: "8px",
      textAlign: "center",
      boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
      maxWidth: "400px",
      width: "100%",
    },
    modalButtons: {
      marginTop: "20px",
    },
    button: {
      margin: "0 10px",
      padding: "10px 20px",
      backgroundColor: "#007bff",
      color: "white",
      border: "none",
      borderRadius: "4px",
      cursor: "pointer",
      fontSize: "16px",
    },
  };

  return (
    <Router>
      {renderRoutes()}
    </Router>
  );
}
